import { useTranslation } from "hooks/useTranslation"
import { Header } from "components/Header"
import { Layout } from "components/Layout"
import { CtaFooter } from "features/Home/components/CtaFooter"
import { ComponentProps } from "react"
import { FreezeDriedBoxRoot, HowItWorksWrapper, CtaFooterWrapper } from "./FreezeDriedBox.styles"
import { Footer } from "components/Footer"
import freezeDriedIngredientPrep from '../../../../../../public/assets/home/freeze-dried-ingredient-preparation.webp'
import { HowItWorks } from "features/Recipes/Overview/components/HowItWorks"
import { HealthToGo } from "./components/HealthToGo"
import { MadeRight } from "features/Recipes/Overview/components/MadeRight"
import { OurIngredients } from "./components/OurIngredients"
import { Hero } from "./components/Hero"
import { useRouter } from "hooks/useRouter"
import { useFetchProductVariants } from "features/ECommerce/api/queries/useFetchProductVariants"
import { useAddToCart } from "features/ECommerce/hooks/useAddToCart"
import { Loader } from "features/components/Loader"

type FreezeDriedBoxOwnProps = ComponentProps<typeof FreezeDriedBoxRoot>
export type FreezeDriedBoxProps = FreezeDriedBoxOwnProps & {}

export const FreezeDriedBox = (_props: FreezeDriedBoxProps) => {
  const { t } = useTranslation()
  const header = <Header />
  const { query } = useRouter()
  const addToCart = useAddToCart()

  const { data: response, status} = useFetchProductVariants({
    page: 1,
    limit: 10,
    textSearch: 'The Raw To-Go Box',
  })

  if (status === 'loading' || status === 'idle' || status === 'error') return <Loader />

  return (
    <FreezeDriedBoxRoot>
      <Layout hideCTA header={header}>
        <Hero onAdd={addToCart} products={response.productVariants} />
        <HealthToGo />
        <OurIngredients />
        <MadeRight hideCta type="freeze-dried" />
        <HowItWorksWrapper>
          <HowItWorks image={freezeDriedIngredientPrep}/>
        </HowItWorksWrapper>
        <CtaFooterWrapper>
          <CtaFooter ctaLink='#hero' cta='products-v2:freeze-dried-box.our-ingredients.cta-button' hideSecondaryCta title="products-v2:freeze-dried-box.footer" />
        </CtaFooterWrapper>
        <Footer />
      </Layout>
    </FreezeDriedBoxRoot>
  )
}

FreezeDriedBox.displayName = 'FreezeDriedBox'
